<template>
  <div class="theme-header">
    <header class="header-style">
      <div class="three-line-btn" @click="isShow = true">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <a  style="display: flex;align-items: center;">
          <div>
            <img style="width: 0.82rem;height: 0.82rem;" src="@/assets/image/lfLogo.png" alt="" />
          </div>
          <!-- <div class="logo" style="margin-left: 0.2rem;">
            <img src="@/assets/image/lf.png" alt="" />
          </div> -->
          <div style="margin-left: 0.1rem;font-size: 0.3rem;font-weight: 600;"  >
            广东老肥科技有限公司
          </div>
        </a>
      </div>

      <div style="width: 30px"></div>
      <nav class="weilaidian-nav" v-show="isShow">
        <a class="nav-color" :class="{ 'is-active': isActive == index }" href="javascript:;"
          v-for="(item, index) in navArray" :key="index" @click.prevent="changeNav(index, item)">
          {{ item.navTitle }}
        </a>
        <a v-show="!isShow" class="nav-color" href="javascript:;" style="margin-right: 0"
          @mouseenter="isShowDownCode = true" @mouseleave="isShowDownCode = false">
          老肥成配小程序
        </a>
        <!-- <button @click="downData" class="nav-color" style="margin-right: 0;margin-left: 20px;">
          APP下载
        </button> -->
        <!-- 缩小的菜单导航(试用) -->
        <div class="close-nav" @click="isShow = false">X</div>
        <div class="float-downCode" v-show="isShowDownCode">
          <img src="@/assets/image/laofeichengpei.jpg" alt="" />
        </div>
      </nav>

    </header>
  </div>
</template>

<script>
import download from '@/utils/lib/pxTorem'
export default {
  name: 'MallHeader',
  data() {
    return {
      isShowDownCode: false,
      isShow: false,
      isActive: window.sessionStorage.getItem('active') || 0,
      navArray: [
        { navTitle: '老肥首页', path: '/homeView' },
        { navTitle: '关于我们', path: '/myAbout' },
        { navTitle: '联系我们', path: '/newAsync' },
      ],
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query.index) {
      console.log(query.index, 11111)
      this.isActive = query.index;
    }
  },
  methods: {
    changeNav(index, item) {
      window.sessionStorage.setItem('active', index);
      this.isActive = index;

      let views = document.body.clientWidth;
      if (views <= 750) {
        this.isShow = false;
      }
      this.$router.push({
        path: item.path,
      });
    },


  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 750px) {
  .theme-header {
    display: flex;
    width: 100%;
    height: 0.875rem;

    .header-style {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 2.3125rem;
      font-size: 0.2rem;
      background: #fff;

      .weilaidian-logo {
        width: 1.675rem;
        height: 0.4125rem;
        margin-bottom: 0.125rem;

        .logo {
          display: flex;
          justify-items: center;
          align-items: center;
          width: 0.8rem;
          height: 0.22rem;
          margin-top: 0.15rem;

          img {
            width: 100%;
          }
        }
      }

      .weilaidian-nav {
        a {
          color: #000;
          margin-right: 30px;
          font-size: 0.2rem !important;

          &:last-child {
            margin-right: 0;
          }

          &:hover {
            color: var(--E52741-color);
          }
        }
      }

      .close-nav {
        display: none;
      }

      .three-line-btn {
        display: none;
      }
    }
  }

  .is-active {
    color: var(--E52741-color) !important;
    font-size: 0.2rem !important;
  }

  .float-downCode {
    z-index: 10000;
    position: absolute;
    top: 0.8125rem;
    right: 2rem;
    width: 2rem;
    height: 2rem;

    img {
      width: 100%;
    }
  }

  .weilaidian-nav {
    display: block !important;
  }
}

@media screen and (max-width: 750px) {
  .theme-header {
    display: flex;
    width: 100%;
    height: 1.7413rem;
    padding: 0 0.5067rem;
    background-color: #fff;

    .header-style {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.2rem;
      background: #fff;

      .weilaidian-logo {
        width: 3rem;
        height: 0.4667rem;

        .logo {
          display: flex;
          justify-items: center;
          align-items: center;
          width: 1.7867rem;
          height: 0.44rem;

          img {
            width: 100%;
          }
        }
      }

      .weilaidian-nav {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: absolute;
        left: -20px;
        top: 0;
        width: 200px;
        height: 300px;
        background-color: #ffffff;
        box-shadow: 6px 6px 28px 1px rgba(212, 212, 212, 0.64);
        text-align: left;
        z-index: 10000;
        animation: clickSync 0.8s;

        a {
          margin: 30px;
          margin-right: 0px !important;
          font-size: 18px;
          color: black !important;
        }

        .close-nav {
          display: block;
          content: 'X';
          position: absolute;
          right: 0;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background-color: #f5f5f5;
          font-size: 18px;
          border-radius: 50%;
          color: red;
        }

        @keyframes clickSync {
          from {
            height: 0;
            display: none;
            font-size: 0;
          }

          to {
            height: 100vh;
            font-size: 18px;
            display: block;
          }
        }
      }

      .three-line-btn {
        padding-top: 5px;
        display: block !important;
        cursor: pointer;
        width: 30px;
        height: 25px;

        div {
          margin: 2px;
          margin-bottom: 4px;
          width: 60%;
          height: 2px;
          background-color: #e52741;
        }
      }
    }
  }
}
</style>
